module.exports = {"shortcutEntry":"快捷入口","customize":"自定义","noShortcutMenu":"暂无快捷菜单","noShortcutMenuTip":"可将常用菜单显示在这里，点击右上角\"自定义\"进行配置","customShortcutEntry":"自定义快捷菜单入口","availableFunctions":"待选功能","totalCount":"（共{count}个）","menuSearch":"菜单名称搜索","selectedFunctions":"已选功能","addShortcutEntry":"增加快捷入口功能","addShortcutEntryDesc":"增加快捷菜单入口和自定义功能，常用功能可进行自定义配置在此处快捷打开，摆脱菜单太多导致很难找到的困扰。"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/zh-CN/shortCutMenu.json
// module id = nWoy
// module chunks = 1